module.exports = __webpack_public_path__ + "static/57-lithium-march2039-cfa85637700a907015f12511b9081c09.jpg";